<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Confirmation Employee Details
    </div>
    <div class="card-body">
        <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
            <div class="row mx-1">
                <div class="col-md-3">
                    <label for="Type" class="form-font-label">Status</label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Approval Status"
                        title="Approval Status" name="ApprovalStatus" [(ngModel)]="Filter.ApprovalStatus"
                        #ApprovalStatus="ngModel" (change)="ClearData()" required>
                        <option value="All">All</option>
                        <option value="Pending">Pending</option>
                        <option value="Approved">Approved</option>
                        <option value="Extended">Extended</option>
                        <option value="Initiated">Initiated</option>
                        <option value="Not-Initiated">Not-Initiated</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label for="BranchID" class="text-label-dark">Branch</label>
                    <ng-select id="BranchID" name="BranchID" [items]="Branchs" bindLabel="BranchName"
                        bindValue="BranchMasterID" placeholder="Branch" [(ngModel)]="this.Filter.BranchId"
                        (change)="ComboLoad('Client');ClearData()">
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label for="ClientId" class="text-label-dark">Client</label>
                    <ng-select id="ClientId" name="ClientId" [items]="Clients" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" placeholder="Client" [(ngModel)]="this.Filter.ClientId"
                        (change)="ComboLoad('Site');ClearData()">
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <label for="SiteId" class="text-label-dark">Site</label>
                    <ng-select id="SiteId" name="SiteId" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                        placeholder="Site" [(ngModel)]="this.Filter.SiteId" (change)="ClearData()">
                    </ng-select>
                </div>
            </div>
            <div class="row mx-1">
                <div class="col-md-3 px-1"><br>
                    &nbsp;&nbsp;<label class="Label">
                        Filter Date
                        <input type="checkbox" name="IsDate" [(ngModel)]="Filter.IsDate" #IsDate="ngModel" ngbCheckbox
                            (change)="ClearData()" />
                    </label>
                </div>
                <div class="col-md-3" *ngIf="Filter.IsDate">
                    <label for="DateSelectionType" class="text-label-dark">Date Type</label>
                    <ng-select id="DateSelectionType" name="DateSelectionType" [items]="DateTypes" bindLabel="DateType"
                        bindValue="DateTypeValue" placeholder="Date Type" [(ngModel)]="this.Filter.DateSelectionType"
                        (change)="ClearData()">
                    </ng-select>
                </div>
                <div class="col-md-3" *ngIf="Filter.IsDate">
                    <label for="FromDateObj" class="form-font-label"><span class="text-danger">*</span>From
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                            [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required
                            readonly (ngModelChange)="ClearData()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-3" *ngIf="Filter.IsDate">
                    <label for="ToDateObj" class="form-font-label"><span class="text-danger">*</span>To
                        Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                            [(ngModel)]="Filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" required readonly
                            (ngModelChange)="ClearData()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>
            </div>
            <div class="row m-1">
                <div class="col">
                    <div class="col-md-3">
                        <label for="Status" class="form-font-label">Employee Type</label>
                        <select class="form-select" aria-label="Status" placeholder="Status" title="Status"
                            name="Status" [(ngModel)]="Filter.EmpType" #Status="ngModel" (change)="ClearData()"
                            required>
                            <option disabled [value]='null'>--Select EmpType--</option>
                            <!-- <option value="All">
                                <div class="row">
                                    <div class="col">All</div>
                                </div>
                            </option> -->
                            <option value="front">
                                <div class="row">
                                    <div class="col">Front</div>
                                </div>
                            </option>
                            <option value="back">
                                <div class="row">
                                    <div class="col">Back</div>
                                </div>
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-auto align-self-end">
                    <button class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-cloud-download me-2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Apply':'Loading...'}}</button>
                </div>
            </div>
        </form>
        <div class="row mx-1">
            <div class="col"></div>
            <div class="col-auto"
                *ngIf="this.common.ToLowerCase(this.Filter.ApprovalStatus) == 'all' || this.common.ToLowerCase(this.Filter.ApprovalStatus) == 'extended' || this.common.ToLowerCase(this.Filter.ApprovalStatus) == 'not-initiated'">
                <form name="TemplateUpdateForm"
                    (ngSubmit)="ESS_EmployeeConfirmationDetails_InsertUpdate(TemplateUpdateForm)"
                    #TemplateUpdateForm="ngForm">
                    <div class="row" style="width: 25rem;">
                        <div class="col-md">
                            <label for="TemplateID" class="form-font-label">Template<span
                                    class="text-danger">*</span></label>
                            <ng-select name="TemplateID" [items]="Templates" bindLabel="TemplateName"
                                bindValue="ESS_QuestionnareTemplateMainId" [(ngModel)]="Filter.TemplateID"
                                placeholder="Select Template" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select template!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-end">
                            <button class="btn btn-outline-primary" [disabled]="isDisabled">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Submit':'Loading...'}}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="card mt-2 border-radius-0 p-1">
    <div class="card-body p-0">
        <!-- <div class="row pb-1">
            <div class="btn-group gap-1" role="group" aria-label="Basic example">
                <button type="button" class="btn btn-outline-primary" style="width:100%"
                    [class.active]="Filter.EmpType === 'front'" (click)="FilterEmpType('front')" value="front">Front
                    Office</button>
                <button type="button" class="btn btn-outline-primary" [class.active]="Filter.EmpType === 'back'"
                    (click)="FilterEmpType('back')" style="width:100%" value="back">Back Office</button>
            </div>
        </div> -->
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered" style="width: 100%;">
            <thead class="table-light">
                <tr>
                    <th scope="col" style="width: 5px;">#</th>
                    <th scope="col"
                        [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'all' && this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'not-initiated'  && this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'extended' }">
                        <input class="form-check-input" type="checkbox" id="IsCheckAll" name="IsCheckAll"
                            (click)="Check($event,0,true)"> Check
                    </th>
                    <th>Employee</th>
                    <th style="width: 150px;">Branch</th>
                    <th>Employee Type</th>
                    <th style="width: 100px;">Joining Date</th>
                    <!-- <th style="width: 100px;">Probation End Date</th> -->
                    <th style="width: 100px;">Confirmation Date</th>
                    <th style="width: 100px;">Confirmation Status</th>
                    <th style="width: 100px;">Working Status</th>
                    <th style="width: 150px;">Questionnaire Template Name</th>
                    <th style="width: 100px;">Initiator Name</th>
                    <th style="width: 120px;">Initiated Date</th>
                    <th style="width: 100px;">Intimation To</th>
                    <th style="width: 120px;">Initimation On</th>
                    <th style="width: 120px;">Pending With Whom</th>
                    <th style="width: 120px;">Approval Status</th>
                    <th style="width: 150px;"
                        [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.EmpType) != 'front'}">Client</th>
                    <th style="width: 150px;"
                        [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.EmpType) != 'front'}">Site</th>
                    <th
                        [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'all' && this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'pending' && this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'initiated'}">
                        Withdraw</th>
                    <!-- <th>{{this.Filter.SelectType == 'Pending'?'Action':'View'}}</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let TableData of TableDatas; let i = index">
                    <th scope="row">{{ i + 1 }}</th>
                    <td class="text-center"
                        [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'all' && this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'not-initiated' && this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'extended'}">
                        <div style="width: 80px;"><input class="form-check-input" type="checkbox" id="IsCheck{{i}}"
                                name="IsCheck{{i}}" (click)="Check($event,i)" [(ngModel)]="TableData['IsCheck']"
                                [disabled]="!(TableData['ESS_QuestionnareTemplateMainId'] == null || TableData['ESS_QuestionnareTemplateMainId'] == '' || TableData['ESS_QuestionnareTemplateMainId'] == 0)">
                        </div>
                    </td>
                    <td>
                        <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''" mat-card-image
                                    class="userImage" [src]="common.PhotoLink(TableData['Photo'])" />
                                <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                    class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(TableData['EmployeeName'])}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label">{{TableData['EmployeeName']}}</span><br />
                                <span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
                                <span class="text-label-light">{{TableData['DesignationName']}}</span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div style="width: 150px;">{{TableData['BranchName']}}</div>
                    </td>
                    <td>
                        <div style="width: 80px;">{{TableData['EmpType']}}</div>
                    </td>
                    <td>
                        <div style="width: 100px;">{{TableData['JoiningDate']}}</div>
                    </td>
                    <!-- <td>
                        <div style="width: 100px;">{{TableData['ProbationEndDate']}}</div>
                    </td> -->
                    <td>
                        <div style="width: 100px;">{{TableData['ConfirmationDate']}}</div>
                    </td>
                    <td>
                        <div style="width: 100px;">{{TableData['IsEmpConfirmed']}}</div>
                    </td>
                    <td>
                        <div style="width: 100px;">{{TableData['WorkingStatus']}}</div>
                    </td>
                    <td>
                        <div style="width: 150px;">{{TableData['TemplateName']}}</div>
                    </td>
                    <td>
                        <div style="width: 100px;">{{TableData['InitiatorName']}}</div>
                    </td>
                    <td>
                        <div style="width: 120px;">{{TableData['InitiatedDate']}}</div>
                    </td>
                    <td>
                        <div style="width: 100px;">{{TableData['IntimationToName']}}</div>
                    </td>
                    <td>
                        <div style="width: 120px;">{{TableData['InitimationOn']}}</div>
                    </td>
                    <td>
                        <div style="width: 120px;">{{TableData['PendingName']}}</div>
                    </td>
                    <td>
                        <div style="width: 120px;">{{StatusReplace(TableData['ApprovalStatus'])}}</div>
                    </td>
                    <td [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.EmpType) != 'front'}">
                        <div style="width: 150px;">{{TableData['ClientName']}}</div>
                    </td>
                    <td [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.EmpType) != 'front'}">
                        <div style="width: 150px;">{{TableData['SiteName']}}</div>
                    </td>
                    <td class="text-end"
                        [ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'all' && this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'pending' && this.common.ToLowerCase(this.Filter.ApprovalStatus) != 'initiated'}">
                        <div style="width: 120px;"
                            *ngIf="this.common.ToLowerCase(TableData['ApprovalStatus']) == 'pending' || this.common.ToLowerCase(TableData['ApprovalStatus']) == 'initiated'">
                            <button type="button" class="btn btn-outline-primary btn-sm"
                                (click)="ESS_EmployeeConfirmationDetails_InsertUpdateWithdraw(i)"><i
                                    class="bi bi-x-circle me-1"></i>Withdraw</button>
                        </div>
                    </td>

                </tr>
            </tbody>
        </table>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="excelDownload()" class="btn btn-primary btn-sm">
                    <i class="bi bi-file-earmark-arrow-down"></i>
                    Excel</button>
            </div>
        </div>
    </div>
</div>